// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__HtUZi","footerContent":"style_footerContent__DinD2","menus":"style_menus__dNPZ+"};